import { render, staticRenderFns } from "./TableControlValue.vue?vue&type=template&id=315e5805"
import script from "./TableControlValue.vue?vue&type=script&lang=js"
export * from "./TableControlValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports